import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { createContext } from "react";

interface ServerData {
  url: string;
  origin: string;
  deviceType?: string;
  apolloClient?: ApolloClient<NormalizedCacheObject>;
}

const DefaultServer: ServerData = {
  url: "",
  origin: "",
  deviceType: "desktop",
};

const ServerContext = createContext<ServerData>(DefaultServer);

export type { ServerData };
export { ServerContext, DefaultServer };
